import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-public-layout-header',
    imports: [],
    templateUrl: './public-layout-header.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PublicLayoutHeaderComponent {}
